import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "..";
import { SSIUplineResponse, SSIUplineParams } from "./ssiUplineAPI.types";

export const ssiUplineApi = createApi({
  reducerPath: "ssiUplineApi",
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    getSSIUplineAPI: builder.query<SSIUplineResponse, SSIUplineParams>({
      query: (params) => {
        const { Abo, Aff, Locale, OverridePeriod, IsoCountryCode, IsoCurrencyCode } = params;
        const queryParams = new URLSearchParams({
          Abo: Abo,
          Aff: Aff,
          Locale: Locale,
          OverridePeriod: OverridePeriod,
          IsoCountryCode: IsoCountryCode,
          IsoCurrencyCode: IsoCurrencyCode,
        });

        return `/acc-action-report-v2-api/api/ssi-tracking/overview?${queryParams}`;
      },
      extraOptions: { urlBase: "apiCFBaseUrl" },
    }),
  }),
});

export const { useGetSSIUplineAPIQuery } = ssiUplineApi;
